<template>
  <naj-box :title="local.agentForm.title">
    <attorney-form
      :form-model="formModel"
      :attorney-social-id="agentSocialId"
      :related-social-id="clientId"
      :view-mode="viewMode"
    ></attorney-form>
  </naj-box>
</template>

<script>
import AttorneyForm from './attorney-form';
import { partyTypeEnum } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';

const { mapGetters } = createNamespacedHelpers('LawsuitModule');

export default {
  inject: ['$validator'],
  components: { AttorneyForm },
  props: ['formModel', 'agentSocialId', 'viewMode'],
  computed: {
    ...mapGetters(['prosecutors', 'defendants']),
    caseParties() {
      return {
        ...this.prosecutors,
        ...this.defendants,
      };
    },
    clientId() {
      if (this.formModel.relatedPartyType == partyTypeEnum.organization || (this.formModel.relatedPartyType == partyTypeEnum.person && this.formModel.isOrganizationOwner)) {
        // if related party type is organization
        const socialId = (this.caseParties[this.formModel.casePartyObjectKey] || {}).socialId;
        if (socialId) return socialId;
      }
      return this.formModel.commercialRegistrationNumber || this.formModel.socialId;
    },
  },
};
</script>
